export const DocuSignSignerStatus = {
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
};

export const DocuSignSignerStatusAlias = {
  [DocuSignSignerStatus.SENT]: 'Sent',
  [DocuSignSignerStatus.DELIVERED]: 'Viewed',
  [DocuSignSignerStatus.COMPLETED]: 'Signed',
  [DocuSignSignerStatus.DECLINED]: 'Declined',
};

export const DocuSignEnvelopeStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  VOIDED: 'VOIDED',
  DECLINED: 'DECLINED',
};

export const DocuSignEnvelopeStatusAlias = {
  [DocuSignEnvelopeStatus.IN_PROGRESS]: 'In progress',
  [DocuSignEnvelopeStatus.COMPLETED]: 'Signed',
  [DocuSignEnvelopeStatus.VOIDED]: 'Voided',
  [DocuSignEnvelopeStatus.DECLINED]: 'Declined',
};
